import { useEffect, useState } from 'react'
import { api, type AccountSummary } from '../lib/api.ts'

/**
 * Which account, on an operator's screen that reads every one of them.
 * Labelled "Conta", the word the menu already uses for them ("Contas").
 *
 * Empty means all, unless the screen is about one account at a time and
 * says so with `allowAll={false}`. Loaded here rather than passed in, because the only
 * screens that need it are super-admin ones and `/api/accounts` answers them.
 */
export function AccountFilter({
  value,
  onChange,
  allowAll = true,
  className,
  selectClassName,
}: {
  value: string
  onChange: (accountId: string) => void
  allowAll?: boolean
  className?: string
  selectClassName?: string
}) {
  const [accounts, setAccounts] = useState<AccountSummary[]>([])

  useEffect(() => {
    void api
      .accounts()
      .then((r) => setAccounts(r.accounts))
      // Without the list the filter offers "todas" alone, which is still true.
      .catch(() => undefined)
  }, [])

  return (
    <label
      className={`text-tSmall text-text-weak flex min-w-0 items-center gap-2 ${className ?? ''}`}
    >
      Conta
      <select
        value={value}
        onChange={(event) => onChange(event.target.value)}
        className={`rounded-base border-stroke-weak bg-background-raised text-tP text-text-strong min-w-0 border px-3 py-1.5 ${selectClassName ?? ''}`}
      >
        {allowAll && <option value="">Todas</option>}
        {accounts.map((account) => (
          <option key={account.id} value={account.id}>
            {account.name}
          </option>
        ))}
      </select>
    </label>
  )
}
